"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var interfaces_1 = require("../../interfaces");
var truncate_1 = require("../_commons/truncate");
var CoreBarChart_1 = require("./CoreBarChart");
var dimensions_1 = require("../_commons/dimensions");
var withChart_1 = require("../_base/withChart");
var sanitizeStacking_1 = require("../_commons/sanitizeStacking");
//
// Internals
//
var barChartDefinition = {
    chartName: "BarChart",
    bucketPropsKeys: ["measures", "viewBy", "stackBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        var measures = sdk_model_1.applyRatioRule(props.measures);
        var viewBy = truncate_1.truncate(props.viewBy, interfaces_1.ViewByAttributesLimit);
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], measures)),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.VIEW], viewBy)),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.STACK, props.stackBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("BarChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.stackedChartDimensions)
            .withExecConfig(execConfig);
    },
    propOverridesFactory: function (props, buckets) {
        return {
            config: sanitizeStacking_1.sanitizeConfig(buckets, props.config),
        };
    },
};
var WrappedBarChart = withChart_1.withChart(barChartDefinition)(CoreBarChart_1.CoreBarChart);
/**
 * [BarChart](http://sdk.gooddata.com/gooddata-ui/docs/bar_chart_component.html)
 *
 * Bar chart shows data in horizontal bars. Bar charts can display one or multiple metrics side by side divided by
 * attribute values or a single measure stacked by attribute values.
 *
 * @remarks See {@link IBarChartProps} to learn how to configure the AreaChart
 * @public
 */
exports.BarChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.viewBy, props.stackBy, props.filters, props.sortBy], props.placeholdersResolutionContext), measures = _a[0], viewBy = _a[1], stackBy = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedBarChart, tslib_1.__assign({}, props, {
        measures: measures,
        viewBy: viewBy,
        stackBy: stackBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=BarChart.js.map